import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'
import { Meeting } from 'src/app/interfaces/meeting.interface';

@Injectable({ providedIn: 'root' })
export class EventoProvider {
  baseAntigaUrl = environment.API_ANTIGA_URL;
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) { }

  getProgamacao(mes: string) {
    return this.http.post<any>(this.baseAntigaUrl + '/programacao/' + mes, {})
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getById(id: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-evento-by-id', { id: id })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  icsCalendar(id: string) {

    return this.http.get<any>(this.baseUrl + '/evento/ics/' + id, {
      headers: { 'Content-Type': 'text/calendar; charset=utf-8', 'Content-Disposition': 'attachment; filename=invite.ics', }
    })
      .pipe(map(data => {
        return data;
      }));
  }


  projetosPessoa(idPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/evento/projetos-pessoa', {
      idPessoa: idPessoa
    })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getPresencas(filtro: { q: string | number | boolean; }, pag: { currentPage: string | number | boolean; }, idEvento: string | number | boolean, idEncontro: string | number | boolean) {
    let params = new HttpParams()
      .set("page", pag.currentPage)
      .set("per-page", "10")
      .set("q", filtro.q)
      .set("idEvento", idEvento)
      .set("idEncontro", idEncontro);

    return this.http.get<any>(this.baseUrl + '/evento-api/get-presencas', { observe: 'response', params: params })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      }));
  }


  getPresencasAvaliacao(filtro: { q: string | number | boolean; }, pag: { currentPage: string | number | boolean; }, idEvento: string | number | boolean, idEncontro: string | number | boolean, idEnsinoAvaliacao: string | number | boolean) {
    let params = new HttpParams()
      .set("page", pag.currentPage)
      .set("per-page", "10")
      .set("q", filtro.q)
      .set("idEvento", idEvento)
      .set("idEncontro", idEncontro)
      .set("idEnsinoAvaliacao", idEnsinoAvaliacao);

    return this.http.get<any>(this.baseUrl + '/evento/get-presencas-avaliacao', { observe: 'response', params: params })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      }));
  }



  getInscritos(filtro: { q: string | number | boolean; }, pag: { currentPage: string | number | boolean; }, idEvento: string | number | boolean) {
    let params = new HttpParams()
      .set("page", pag.currentPage)
      .set("per-page", "10")
      .set("q", filtro.q)
      .set("idEvento", idEvento);

    return this.http.get<any>(this.baseUrl + '/evento/lista-inscritos', { observe: 'response', params: params })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      }));
  }

  getInscritosFiltro(filtro: { q: string | number | boolean; }, pag: { currentPage: string | number | boolean; }, idEvento: string | number | boolean, s: any) {
    let params = new HttpParams()
      .set("expand", "encontroBasic")
      .set("page", pag.currentPage)
      .set("per-page", "10")
      .set("q", filtro.q)
      .set("s", 'true')
      .set("idEvento", idEvento);

    return this.http.get<any>(this.baseUrl + '/evento/lista-inscritos-filtro', { observe: 'response', params: params })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      }));
  }


  getDadosInscricao(idInscricao: string) {
    return this.http.get<any>(this.baseUrl + '/evento/dados-inscricao?idInscricao=' + idInscricao)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  checkin(idEncontro: any, idInscricao: any, idPessoa: any, idPessoaFamiliarCheckIn: any, idPresenca: any, obsCheckIn: any) {
    return this.http.post<any>(this.baseUrl + '/evento/check-in',
      { idEncontro: idEncontro, idInscricao: idInscricao, idPessoa: idPessoa, idPessoaFamiliarCheckIn: idPessoaFamiliarCheckIn, idPresenca: idPresenca, obsCheckIn: obsCheckIn }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  checkout(idEncontro: any, idInscricao: any, idPessoa: any, idPessoaFamiliarCheckOut: any, idPresenca: any, obsCheckOut: any) {
    return this.http.post<any>(this.baseUrl + '/evento/check-out',
      { idEncontro: idEncontro, idInscricao: idInscricao, idPessoa: idPessoa, idPessoaFamiliarCheckOut: idPessoaFamiliarCheckOut, idPresenca: idPresenca, obsCheckOut: obsCheckOut }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarPresenca(presenca: { idEventoEncontroPresenca: any; idPessoa: any; idEventoEncontro: any; idEncontro: any; idEventoInscricao: any; idEvento: any; valor: any; aproveitamento: any; presenca: any; observacao: any; nota_avaliacao: any; data_avaliacao: any; idEnsinoAvaliacaoEventoPresenca: any; }) {
    return this.http.post<any>(this.baseUrl + '/evento/salvar-presenca',
      {
        idEventoEncontroPresenca: presenca.idEventoEncontroPresenca,
        idPessoa: presenca.idPessoa,
        idEventoEncontro: presenca.idEventoEncontro,
        idEncontro: presenca.idEncontro,
        idEventoInscricao: presenca.idEventoInscricao,
        idEvento: presenca.idEvento,
        valor: presenca.valor,
        aproveitamento: presenca.aproveitamento,
        presenca: presenca.presenca,
        observacao: presenca.observacao,

        nota_avaliacao: presenca.nota_avaliacao,
        data_avaliacao: presenca.data_avaliacao,
        idEnsinoAvaliacaoEventoPresenca: presenca.idEnsinoAvaliacaoEventoPresenca
      }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getEncarregados(filtro: { q: any; }, pag: { currentPage: any; }, idEventoEncontro: any) {
    return this.http.get<any>(this.baseUrl + '/evento-api/buscar-encarregados',
      {
        observe: 'response', params:
        {
          "expand": "pessoa,pessoaFuncoesEspec",
          "page": pag.currentPage,
          "per-page": "10",
          "q": filtro.q,
          "idEventoEncontro": idEventoEncontro
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          encarregados: data.body,
          pagination: pag
        };
      }));
  }

  getEventos(dados: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-eventos', dados)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  postEventosTipos(dados: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/post-eventos-tipos', dados)
    .pipe(map(data =>{
      if (!data.erro) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getEventosInscrito(dados: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-eventos-inscrito', dados)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getLayoutAula(idAula: any, idEvento: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-layout-aula', { idAula: idAula, idEvento: idEvento, })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getNotasEncontro(idEncontro: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-notas-encontro', { idEncontro: idEncontro })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  verificaInscricaoPessoa(idEvento: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/verifica-inscricao-pessoa', { idEvento: idEvento })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getNotasParticipante(idPessoa: any, idEncontro: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-notas-participante', { idPessoa: idPessoa, idEncontro: idEncontro })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  salvarNotasParticipante(idEncontro: any, idPessoa: any, atividades: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/salvar-notas-participante', { idEncontro: idEncontro, idPessoa: idPessoa, atividades: atividades })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  salvarPresencaParticipante(pessoa: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/salvar-presenca-participante', { pessoa: pessoa })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  inscreverPessoaEvento(idEvento: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/inscrever-pessoa-evento', { idEvento: idEvento })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  verificaAdmin(idEncontro: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/verifica-admin', { idEncontro: idEncontro })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  resumoEnquete(idInscricao: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/resumo-enquete', { idInscricao: idInscricao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  buscarServicosInscricao(idInscricao: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/buscar-servicos-inscricao', { idInscricao: idInscricao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  buscaDetalhesPessoa(idEvento: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/buscar-detalhes-pessoa', { idEvento: idEvento })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getLotesByIdInscricao(idInscricao: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-lotes-by-id-inscricao', { idInscricao: idInscricao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  verificaCheckIn(idEvento: any, idEncontro: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/verifica-checkin', { idEvento: idEvento, idEncontro: idEncontro })
      .pipe(map(data => {
        return data;
      }));
  }

  salvarPresencaCode(uuid: any, idEncontro: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/salvar-presenca-code', { uuid: uuid, idEncontro: idEncontro })
      .pipe(map(data => {
        return data;
      }));
  }


  getEncontrosPassados(uuid: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-encontros-passados', { uuid: uuid })
      .pipe(map(data => {
        return data;
      }));
  }

  getDetalhesPresenca(idInscricao: any, idPresenca: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-detalhes-presenca', { idInscricao: idInscricao, idPresenca: idPresenca })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  checkInAvulso(idPresenca: any, qntChecks: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/check-in-avulso', { idPresenca: idPresenca, qntChecks: qntChecks })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getPessoasReposicao(idInscricao: string) {
    return this.http.get<any>(this.baseUrl + '/evento-api/get-pessoas-reposicao?idInscricao=' + idInscricao)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getServicosByIdInscricao(idInscricao: string) {
    return this.http.get<any>(this.baseUrl + '/evento-api/get-servicos-by-id-inscricao?idInscricao=' + idInscricao)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  retirarServico(idInscricaoxservico: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/retirar-servico', { idInscricaoxservico: idInscricaoxservico })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  retirarTodosServicos(idInscricao: string) {
    return this.http.get<any>(this.baseUrl + '/evento-api/retirar-todos-servicos?idInscricao=' + idInscricao)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getReposicao(filtro: { q: string | number | boolean; }, pag: { currentPage: string | number | boolean; }, idEncontro: string | number | boolean) {
    let params = new HttpParams()
      .set("page", pag.currentPage)
      .set("per-page", "10")
      .set("busca", filtro.q)
      .set("idEncontro", idEncontro);

    return this.http.get<any>(this.baseUrl + '/evento-api/get-reposicao', { observe: 'response', params: params })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      }));
  }

  getEnsinosReposicao(idAula: any, idModulo: any, idEvento: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-ensinos-reposicao', { idAula: idAula, idModulo: idModulo, idEvento: idEvento })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getInscritosEnsino(idEnsino: any, ensinoReposicao: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-inscritos-ensino', { idEnsino: idEnsino, ensinoReposicao: ensinoReposicao })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  validaPessoaReposicao(idAula: any, idPessoa: any, idEvento: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/valida-pessoa-reposicao', { idAula: idAula, idPessoa: idPessoa, idEvento: idEvento })
      .pipe(map(data => {
        return data;
      }));
  }

  salvarReposicao(idEnsino: any, idPessoa: any, idEncontro: any, idAula: any) {
    return this.http.post<any>(this.baseUrl + '/evento-api/salvar-reposicao', { idEnsino: idEnsino, idPessoa: idPessoa, idEncontro: idEncontro, idAula: idAula })
      .pipe(map(data => {
        return data;
      }));
  }
  getEventosEnsinosCertificados(idPessoa: any) {
    return this.http
    .get<any>(this.baseUrl + '/evento-api/get-eventos-ensinos-certificados', {
      observe: 'response',
      params: { idPessoa: idPessoa },
    })
    .pipe(map((data) => {
      if (data.body) {
        return data.body;
      } else {
        return false;
      }
      })
    );
  }

  quantidadeInscritos(idEvento: any) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/quantidade-inscritos', { idEvento: idEvento })
      .pipe(map((data) => {
        return data;
      }));
  }

  postEventoByUuid(uuid: any) {
    return this.http.post<Meeting[]>(this.baseUrl + '/evento-api/post-evento-by-uuid', { uuid: uuid })
      .pipe(map(data => {
        return data;
      }));
  }

  public encodeObjToUrl(obj: any): string {
    let str = JSON.stringify(obj);

    str = str.replace(/[\u007F-\uFFFF]/g, function (chr) {
      return '\\u' + ('0000' + chr.charCodeAt(0).toString(16)).substr(-4);
    });

    const url = btoa(str);
    return encodeURIComponent(url);
  }

  loginExterno(userUuid: string, eventSlug: string, tenantID: string, isInscrito: boolean) {
    return this.http.post<any>(
      `${this.baseUrl}/evento-api/external-login-proxy`,
      {
        userUuid: userUuid,
        slug: eventSlug,
        instituicaoSlug: tenantID,
        isInscrito: isInscrito
      }
    );
  }

  quantidadeCheckin(idEvento: any, idEncontro: any) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/quantidade-checkin', {
        idEvento: idEvento,
        idEncontro: idEncontro,
      })
      .pipe(map((data) => {
        return data;
      }));
  }

  getInfoAdicionais(idPessoa: any, idEvento: any, idInscricao: any) {
    return this.http.get<any>(this.baseUrl + '/evento-api/get-info-adicionais', {
      params: {
        idPessoa: idPessoa,
        idEvento: idEvento,
        idInscricao: idInscricao
      }
    })
  }
}